export const checkSecrets = (): void => {
  import('./secrets').catch(() => {
    console.error(
      "Unable to find the required './src/Client/src/config/secrets/secrets.ts' file. " +
        'Please ensure that you have followed the project getting started.'
    );
  });
}
